module.exports = __webpack_public_path__ + "static/southern-colorado-92269b54778152364763451a8c31caa6.png";